var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSparkle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 81,
    viewBox: "0 0 65 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter0_f_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.625 73.1371C32.625 73.1371 32.625 40.5685 57.25 40.5685C32.625 40.5685 32.625 8 32.625 8C32.625 8 32.625 40.5685 8 40.5685C32.625 40.5685 32.625 73.1371 32.625 73.1371Z",
    fill: "#EAB143"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.625 62.1152C32.625 62.1152 32.625 40.5684 48.7852 40.5684C32.625 40.5684 32.625 19.0215 32.625 19.0215C32.625 19.0215 32.625 40.5684 16.4648 40.5684C32.625 40.5684 32.625 62.1152 32.625 62.1152Z",
    fill: "#FFF5E1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_1",
    x: 0.500001,
    y: 0.500001,
    width: 64.25,
    height: 80.1367,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75,
    result: "effect1_foregroundBlur_0_1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkle);
export default __webpack_public_path__ + "static/media/sparkle.c07d295302a675666bbaf5a805d0f248.svg";
export { ForwardRef as ReactComponent };